import { Routes, Route, Outlet, Navigate, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import './styles/App.css';
import Menu from "./components/Menu";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Partners from "./pages/Partners";
import Activities from "./pages/Activities";
import ActivityDetails from "./pages/ActivityDetails";
import Projects from "./pages/Projects";
import ProjectDetails from "./pages/ProjectDetails";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import ContactPage from "./components/ContactPage";
import Reservation from "./components/Reservation";
import ProtectedRoute from "./components/ProtectedRoute";
import NotFound from "./pages/NotFound";

// Redirige /admin vers /admin/dashboard (connecté) ou /admin/login (non connecté)
function AdminRedirect() {
  const token = localStorage.getItem('access_token');
  return token
    ? <Navigate to="/admin/dashboard" replace />
    : <Navigate to="/admin/login" replace />;
}

// Remet le scroll en haut à chaque changement de route
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

// Layout public : Menu + contenu + Footer
function PublicLayout() {
  return (
    <>
      <Menu />
      <Outlet />
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <ScrollToTop />
      <Routes>

        {/* ══ Routes Admin (sans Menu/Footer public) ══ */}
        <Route path="/admin" element={<AdminRedirect />} />
        <Route path="/admin/login" element={<AdminLogin />} />

        <Route
          path="/admin/dashboard"
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />


        <Route
          path="/admin/partners"
          element={
            <ProtectedRoute>
              <Navigate to="/admin/dashboard" state={{ section: 'partenaires' }} replace />
            </ProtectedRoute>
          }
        />

        {/* ══ Routes Publiques (avec Menu + Footer) ══ */}
        <Route element={<PublicLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/partners" element={<Partners />} />
          <Route path="/activites" element={<Activities />} />
          <Route path="/activites/:id" element={<ActivityDetails />} />
          <Route path="/projets" element={<Projects />} />
          <Route path="/projets/:id" element={<ProjectDetails />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/reservation" element={<Reservation />} />
        </Route>

        {/* ══ Route 404 — Catch-all ══ */}
        <Route path="*" element={<NotFound />} />

      </Routes>
    </div>
  );
}

export default App;
